var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfluence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.29596 47.9031C1.63645 48.9774 0.889494 50.2364 0.299926 51.2332C0.170021 51.4555 0.0875815 51.7029 0.0501089 51.9577C0.0145382 52.2135 0.0281042 52.4738 0.0900796 52.7246C0.150036 52.9769 0.259955 53.2118 0.409845 53.4216C0.559736 53.6315 0.749597 53.8113 0.966937 53.9512L14.2147 62.1177C14.4421 62.2601 14.6994 62.3551 14.9667 62.3975C15.2315 62.44 15.5063 62.43 15.7686 62.3651C16.0309 62.3001 16.2782 62.1852 16.4956 62.0253C16.7129 61.8654 16.8953 61.6631 17.0327 61.4307C17.5673 60.5414 18.2443 59.3897 18.9712 58.1606C24.2224 49.5494 29.5435 50.6037 39.049 55.1229L52.1894 61.3533C52.4354 61.4713 52.7027 61.5385 52.9752 61.551C53.2478 61.5634 53.52 61.5208 53.7758 61.4257C54.0306 61.3308 54.2654 61.1859 54.4628 60.9986C54.6626 60.8112 54.82 60.5864 54.9299 60.3365L61.2378 46.1145C61.3452 45.8746 61.4052 45.6173 61.4127 45.355C61.4227 45.0952 61.3802 44.8329 61.2902 44.5881C61.2003 44.3433 61.0654 44.1159 60.8905 43.9211C60.7157 43.7262 60.5058 43.5688 60.2685 43.4514C57.498 42.1474 51.9846 39.5817 47.0432 37.1635C29.0689 28.4924 13.9025 29.0644 2.29596 47.9031Z",
    fill: "url(#paint0_linear_536_8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6948 15.5743C62.3618 14.5001 63.1088 13.2436 63.6909 12.2468C63.8233 12.0194 63.9107 11.7671 63.9482 11.5048C63.9856 11.245 63.9706 10.9777 63.9057 10.7229C63.8393 10.4675 63.7239 10.2273 63.5659 10.0159C63.4083 9.80384 63.2105 9.62476 62.9839 9.4888L49.7561 1.32228C49.5262 1.17989 49.2714 1.08496 49.0041 1.04249C48.7368 1.00002 48.4645 1.01251 48.2022 1.07496C47.9399 1.13992 47.6926 1.25483 47.4752 1.41471C47.2579 1.5746 47.0755 1.77695 46.9356 2.00928C46.4135 2.89863 45.724 4.05028 44.997 5.27938C39.7259 13.9305 34.4548 12.8763 24.9392 8.35713L11.8114 2.12419C11.5665 2.00678 11.3017 1.93683 11.0319 1.92184C10.7621 1.90436 10.4898 1.94433 10.235 2.03426C9.98019 2.12419 9.74537 2.26409 9.54551 2.44646C9.34316 2.62882 9.18328 2.84866 9.06836 3.09348L2.76048 17.3555C2.54369 17.8393 2.52309 18.3883 2.70302 18.8869C2.79296 19.1342 2.93036 19.3616 3.10523 19.5564C3.2801 19.7513 3.49244 19.9112 3.72977 20.0261C6.51023 21.3326 12.0237 23.8957 16.9551 26.3165C34.882 34.9851 50.0958 34.4155 61.6948 15.5743Z",
    fill: "url(#paint1_linear_536_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_8",
    x1: 60.8131,
    y1: 66.3466,
    x2: 20.7922,
    y2: 43.3462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_8",
    x1: 3.17593,
    y1: -2.87714,
    x2: 43.2066,
    y2: 20.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 61.44,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfluence);
export default __webpack_public_path__ + "static/media/Confluence.ec09cee77127d8e460a7104864bb3e26.svg";
export { ForwardRef as ReactComponent };